
import React, { useEffect, useState } from 'react';
import { Loader2 } from 'lucide-react';
import NavBar from '@/components/NavBar';
import { Alert, AlertDescription } from '@/components/ui/alert';
import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/button';

const DashboardLoading = () => {
  const [showHelp, setShowHelp] = useState(false);
  const [loadingTime, setLoadingTime] = useState(0);
  
  // Show help message after 5 seconds of loading
  useEffect(() => {
    const timer = setTimeout(() => {
      setShowHelp(true);
    }, 5000);
    
    // Track loading time
    const interval = setInterval(() => {
      setLoadingTime(prev => prev + 1);
    }, 1000);
    
    return () => {
      clearTimeout(timer);
      clearInterval(interval);
    };
  }, []);
  
  return (
    <div className="min-h-screen flex flex-col">
      <NavBar />
      <div className="flex-grow flex items-center justify-center">
        <div className="text-center max-w-md px-4">
          <Loader2 className="h-16 w-16 animate-spin mx-auto text-primary" />
          <p className="mt-6 text-xl font-medium">
            Loading your dashboard...
          </p>
          <p className="mt-2 text-muted-foreground">
            Please wait while we prepare your personalized dashboard
          </p>
          <p className="mt-2 text-sm text-muted-foreground">
            Loading for {loadingTime} seconds
          </p>
          
          {showHelp && (
            <Alert className="mt-8 bg-background border border-primary/20">
              <AlertCircle className="h-4 w-4 text-primary" />
              <AlertDescription className="text-sm">
                <p>Taking longer than expected? There might be issues connecting to our database.</p>
                <p className="mt-2">Try refreshing the page or check your network connection.</p>
                <Button 
                  className="mt-4 w-full"
                  onClick={() => window.location.reload()}
                >
                  Refresh Page
                </Button>
              </AlertDescription>
            </Alert>
          )}
        </div>
      </div>
    </div>
  );
};

export default DashboardLoading;
